import React, { Component } from "react"
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { fetchHubSpotByEmail } from 'app/modules/hubspot/actions'
import { compose, mapProps, branch, renderNothing } from 'recompose'
import _get from 'lodash/get'
import _isEqual from 'lodash/isEqual'
import cx from 'classnames'

import { Loader } from '@driftt/tide-core-legacy'
import Icon from 'svg-inline-react'
import HUBSPOT_ICON from '!svg-inline?removeTags=true!images/svg/hubspot-logo.svg'
import { conversationSection } from "./style"
import { makeGetHubspotByEmail } from 'app/modules/hubspot/selectors'
import { firstEndUserMessage } from 'app/modules/message/selectors'

class HubSpotSection extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      error: null,
      data: null
    }
    this.enrichConversation()
  }

  componentWillReceiveProps(nextProps) {
    const { hubSpotEnrichment } = this.props
    if (!_isEqual(hubSpotEnrichment, nextProps.hubSpotEnrichment,)) {
      this.setState({
        loading: _get(nextProps.hubSpotEnrichment, "loading", false),
        error: _get(nextProps.hubSpotEnrichment, "error", {}),
        data: _get(nextProps.hubSpotEnrichment, "data", {})
      })
    }
  }

  enrichConversation = () => {
    const { email, actions } = this.props
    return actions.fetchHubSpotByEmail({ email })
  }

  renderHubSpotInfo = () => {
    const { data } = this.state
    const { contact, opportunities } = data
    const { properties } = contact
    const emptyValue = { 'value': null }
    const contactOwner = _get(data, 'owner', null)
    return <div>
      { opportunities && !!opportunities.length && this.renderHubSpotOpportunityBar() }
      { renderRow("Contact Owner", _get(contactOwner, 'name')) }
      { renderRow("Lifecycle Stage", _get(properties, 'lifecyclestage', emptyValue).value) }
      { renderRow("Lead Status", _get(properties, 'hs_lead_status', emptyValue).value) }
      { renderRow("HubSpot Score", _get(properties, 'hubspotscore', emptyValue).value) }
      {<a href={_get(contact, 'profileUrl')} target="_blank">
        <div className="view-in-hubspot-bar">
          View in HubSpot
        </div>
      </a>}
    </div>
  }

  renderErrorState = () => {
    const { 
      error,
    } = this.state
    return <p>
      { error.status === 404 ? 
        "Couldn't find matching record in HubSpot" :
        "Error fetching data from HubSpot" }
    </p>
  }

  render() {
    const {
      className
    } = this.props
    const { 
      loading, 
      error
     } = this.state

    return (
      <div className={cx(conversationSection, className)}>
      <div className="section-header">
        <Icon src={ HUBSPOT_ICON } name="HUBSPOT_ICON" className="header-icon" />
        <span className="section-title">
          HubSpot Details
        </span>
      </div>
      <div className="section-body">
        { loading && <Loader /> }
        { !!_get(error, "status") && this.renderErrorState() }
        { (!loading && !_get(error, "status")) && this.renderHubSpotInfo() }
      </div>
      </div>
    )
  }
}

HubSpotSection.props = {
  email: String
}

const renderRow = (header, value) =>
<div className="hubspot-enrichment-body-row">
  <div className="hubspot-enrichment-row-header">
    { header }
  </div>
  <div className="hubspot-enrichment-row-body">
    { value ? value : "N/A" }
  </div>
</div>

const makeMapStateToProps = () => {
  const firstEndUserMessageSelector = firstEndUserMessage()
  const getHubspotByEmail = makeGetHubspotByEmail()
  
  return (state, props) => {
    const { conversationId, email } = props

    return {
      firstEndUserMessage: firstEndUserMessageSelector(state, { conversationId }),
      hubSpotEnrichment: getHubspotByEmail(state, email)
    }
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchHubSpotByEmail,
  }, dispatch)
})

export default compose(
  connect(makeMapStateToProps, mapDispatchToProps),
  branch(props => !!props.conversationId && !props.firstEndUserMessage, renderNothing),
  mapProps(({ ...props }) => {
    return {
      ...props,
    }
  })
)(HubSpotSection)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/HubSpotSection/index.js